import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { GateWay } from '../gateway.model';
import { GateWayActionTypes, GateWayActions } from '../actions/gateway.actions';


export interface GateWayState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: GateWayState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: GateWayActions
): GateWayState {
  switch (action.type) {

    case GateWayActionTypes.UpsertGatewayList: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case GateWayActionTypes.ReadGatewayList: {
      return {...state, Loaded: false, Loading: true, entities: action.payload};
    }

    case GateWayActionTypes.ReadGatewayListFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export const getGateWayState = (state: GateWayState) => state;
